import { useEffect } from "react";

const CandidateList = () => {

  useEffect(() => {
    window.location.href =
      "https://epapercdn.sandesh.com/pdf/2026/Candidate%20List%20Gujarat%20Congress_Press%205-4-2026.pdf";
  }, []);

  return null;
};

export default CandidateList;